// VER-218: in-memory holder for the Console access token.
// Deliberately NOT localStorage — a JS-readable persistent token is the thing we
// want to avoid (XSS). This lives only for the tab's lifetime and is re-minted
// from the httpOnly refresh cookie on page load (see SessionProvider bootstrap).
let accessToken = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = token;
}

export function clearAccessToken() {
  accessToken = null;
}
